import { render, staticRenderFns } from "./MetadataImport.vue?vue&type=template&id=b37d3afc&"
import script from "./MetadataImport.vue?vue&type=script&lang=ts&"
export * from "./MetadataImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports